/** @format */

const template = `
<div class="modal-header">
  <h2 class="modal-title"> <span translate="CUSTOM_STUDY_DRAFT_INFO_MODAL.TITLE"></span>: {{ $ctrl.resolve.customStudyDraft.name }} </h2>
  <button type="button" class="modal-close" ng-click="$ctrl.close()" aria-label="{{'ARIA_LABEL.CLOSE' | translate}}">
    <sis-icon icon="ring-close"></sis-icon>
  </button>
</div>
<div class="modal-body">
  <div class="form-group">
    <label translate="CUSTOM_STUDY_DRAFT_INFO_MODAL.NAME">Nimi</label>
    <p class="form-control-static"> {{ $ctrl.resolve.customStudyDraft.name }} </p>
  </div>

  <div class="form-group">
    <label translate="CUSTOM_STUDY_DRAFT_INFO_MODAL.CREDITS">Suunniteltu laajuus</label>
    <p class="form-control-static"> {{ $ctrl.resolve.customStudyDraft.credits | decimalNumber }} </p>
  </div>

  <div class="form-group">
    <label translate="CUSTOM_STUDY_DRAFT_INFO_MODAL.LOCATION">Paikka</label>
    <p class="form-control-static"> {{ $ctrl.resolve.customStudyDraft.location }} </p>
  </div>

  <div class="form-group">
    <label translate="CUSTOM_STUDY_DRAFT_INFO_MODAL.DESCRIPTION">Kuvaus</label>
    <p class="form-control-static"> {{ $ctrl.resolve.customStudyDraft.description }} </p>
  </div>
</div>
`;
export default template;
